import React, { ReactElement, useRef } from 'react';
import GenericMultiSelectDropdown from '../reportingUtils/ReportingMultiSelectDropdown';
import '../ReportingAndAnalytics.less';
import GenericExpandableRadioFilter from '../reportingUtils/ReportingRadioSelect';
import { useDispatch } from 'react-redux';
import {
  setDateRangeClicked,
  setResetBtnClicked,
  setTransactionReportFilters,
} from '../../../store/actions/reportingAndAnalyticsActions';
import { DEFAULT_REPORTING_FILTERS, REPORTING_CONSTANTS } from '../reportingUtils/reportingAndAnalyticsConstants';

const TransactionCountFilters = (props: any): ReactElement => {
  const { configuredPayers, availableStatus, statusFilterLabel, dateRangeConfig } = props;
  const dispatch = useDispatch();
  const claimStatusRef = useRef<any>();
  const claimTypeRef = useRef<any>();
  const radioRef = useRef<any>();

  const handleReset = (): void => {
    if (claimStatusRef?.current || claimTypeRef?.current || radioRef?.current) {
      claimStatusRef?.current?.resetFilter();
      claimTypeRef?.current?.resetFilter();
      radioRef?.current?.resetFilter();
    }
    dispatch(setResetBtnClicked());
    dispatch(setDateRangeClicked(false));
    dispatch(
      setTransactionReportFilters(DEFAULT_REPORTING_FILTERS),
    );
  };

  const handlePayerCheckboxChange = (value: string[]): void => {
    dispatch(setTransactionReportFilters({ payer: value }));
  };

  const handleStatusCheckboxChange = (value: string[]): void => {
    dispatch(setTransactionReportFilters({ claimStatus: value }));
  };

  const handleRadioChange = (value: string): void => {
    dispatch(setDateRangeClicked(true));
    dispatch(setTransactionReportFilters({ dateFilter: value }));
  };

  return (
    <div className="transaction-count-filters">
      <div className="filter-bar">
        <span className="filter-label">Filter By</span>
        <div className="reset-btn mouse-pointer" onClick={handleReset}>
          Reset
        </div>
      </div>

      <GenericExpandableRadioFilter
        ref={radioRef}
        label="Date Range"
        options={dateRangeConfig}
        onChange={handleRadioChange}
      />

      <GenericMultiSelectDropdown
        ref={claimStatusRef}
        label="Payers"
        options={configuredPayers}
        onChange={(Item: string[]): void => handlePayerCheckboxChange(Item)}
        showMoreLimit={5}
        enableSearch={true}
      />

      <div>
        <GenericMultiSelectDropdown
          ref={claimTypeRef}
          label={statusFilterLabel ?? REPORTING_CONSTANTS.STATUS_STRING}
          options={availableStatus}
          onChange={(Item: string[]): void => handleStatusCheckboxChange(Item)}
          showMoreLimit={10}
        />
      </div>
    </div>
  );
};
export default TransactionCountFilters;
